import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listLedgerAccounts,
  getLedgerAccount,
  createLedgerAccount,
} from "@/services/ledger.service";

// Env is part of every query key so switching LIVE/SANDBOX refetches cleanly
// and never shows stale data from the other environment.

export const useLedgerAccounts = (params = {}, options = {}) =>
  useQuery({
    queryKey: [
      "ledger-accounts",
      params.environment,
      params.page,
      params.size,
      params.search,
      params.status,
    ],
    queryFn: () => listLedgerAccounts(params),
    enabled: Boolean(params.environment),
    // No keepPreviousData: we WANT isLoading to flip true on search/page change
    // so the table shows its skeleton (matches the rest of the app's tables).
    ...options,
  });

export const useLedgerAccount = (accountNumber, environment, options = {}) =>
  useQuery({
    queryKey: ["ledger-account", environment, accountNumber],
    queryFn: () => getLedgerAccount({ accountNumber, environment }),
    enabled: Boolean(accountNumber && environment),
    ...options,
  });

export const useCreateLedgerAccount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createLedgerAccount,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["ledger-accounts", variables.environment],
      });
    },
  });
};
